<via-loading-spinner *ngIf="loading"></via-loading-spinner>
<via-keyword-filter-bar (searchFilters)="searchFiltersByText($event)" (clearSearch)="resetSearch()"
    [isDisabled]="selectedBrands.length > 0">
</via-keyword-filter-bar>
<div class="e-scrollable-area" [scrollWindow]="false" infinite-scroll [infiniteScrollDistance]="0.1"
    (scrolled)="onScrollDown()" #scrollArea>
    <h3 class="e-filter-options-heading">All Brands <span>by total SKUs</span></h3>
    <div *ngFor="let page of pages; index as i" #page>
        <div class="e-page-anchor" #pageAnchor></div>
        <via-checkbox-tree *ngIf="page.value.length > 0" [tree]="page.value" (onChange)="selectionChanged()"
            [branchCount]="3" [events]="eventsSubject.asObservable()" [triStateCheckboxesEnabled]="true"
            [triStateCheckboxesFlow]="triStateFlow" (selectedSingularNodeChange)="onCheckboxStateChange($event, pages)"
            (afterViewInit)="checkScrollArea()">
        </via-checkbox-tree>
        <via-ui-page-break [totalSize]="totalSize" [pageNumber]="i + 1"></via-ui-page-break>
    </div>
    <ng-container *ngIf="noResultsMessage !== ''">
        <div class="e-no-results-found-text">{{noResultsMessage}}</div>
    </ng-container>
    <p *ngIf="showError">{{ errorMessage }}</p>
</div>